<template>
	<div class="cta">
		<a :href="ville.info.ctaUrl" class="cta button is-fullwidth" target="_blank">
			{{ ville.info.ctaLabel}} <fleche-icon class="icon"/>
		</a>
	</div>
</template>

<script>

import FlecheIcon from './icons/fleche-droite.svg';
import villeData from "@ville/data";

export default {
	name: 'CtaControl',
	data() {
		return {
			ville: villeData
		}
	},
	components: {
		FlecheIcon,
	},
}
</script>


<style scoped lang="scss">
.cta {
	//max-width: 348px;

	width: 100%;
//	padding: 0 12px;
/*
	@include from($tablet) {
		max-width: 424px;
	}

	@include from($desktop) {
		max-width: 524px;
	}
*/
	.button {
		@include base-box() {
			height: auto;
			line-height: 2;
			width: 100%;
			background-color: $bg-cta;
			color: #fff;
			text-align: center;
			padding: 12px 22px;
			border-radius: 4px;
			display: flex;

			font-family: "Archivo", sans-serif;
			font-weight: 700;
			font-size: 18px;

		}

		.icon {
			margin-left: .6rem !important;
			fill: #fff;
			transform-origin: center;
			transform: scale(.7);
		}

	}
}

</style>
